class BlogCarouselSection extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(".blog-carousel__track");
    this.prevBtn = this.querySelector(".blog-carousel__nav-btn--prev");
    this.nextBtn = this.querySelector(".blog-carousel__nav-btn--next");
    this.dots = Array.from(this.querySelectorAll(".blog-carousel__dot"));

    if (this.prevBtn)
      this.prevBtn.addEventListener("click", () => this.slide(-1));
    if (this.nextBtn)
      this.nextBtn.addEventListener("click", () => this.slide(1));

    this.dots.forEach((dot, i) => {
      dot.addEventListener("click", () => this.scrollToPage(i));
    });

    if (this.track) {
      this.track.addEventListener("scroll", () => this.onScroll(), {
        passive: true,
      });
    }

    this.updateNavState();
  }

  get isMobile() {
    return window.innerWidth < 750;
  }

  get cardsPerView() {
    const varName = this.isMobile ? "--bc-cards-mobile" : "--bc-cards-desktop";
    const val = parseInt(
      getComputedStyle(this).getPropertyValue(varName).trim(),
      10,
    );
    return isNaN(val) ? (this.isMobile ? 1 : 3) : val;
  }

  get cards() {
    return Array.from(this.track.querySelectorAll(".blog-carousel__card"));
  }

  get cardWidth() {
    const card = this.cards[0];
    if (!card) return 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    return card.offsetWidth + gap;
  }

  slide(direction) {
    if (!this.track) return;
    const step = this.isMobile ? this.cardsPerView : 1;
    this.track.scrollBy({
      left: this.cardWidth * direction * step,
      behavior: "smooth",
    });
  }

  scrollToPage(pageIndex) {
    if (!this.track) return;
    const cards = this.cards;
    const step = this.isMobile ? this.cardsPerView : 1;
    const cardIndex = pageIndex * step;
    const card = cards[cardIndex];
    if (!card) return;
    const trackPaddingLeft =
      parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
    this.track.scrollTo({
      left: card.offsetLeft - trackPaddingLeft,
      behavior: "smooth",
    });
  }

  onScroll() {
    this.updateDots();
    this.updateNavState();
  }

  updateDots() {
    if (!this.dots.length || !this.track) return;

    const atEnd =
      this.track.scrollLeft + this.track.offsetWidth >=
      this.track.scrollWidth - 2;
    if (atEnd) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle(
          "blog-carousel__dot--active",
          i === this.dots.length - 1,
        );
      });
      return;
    }

    const step = this.isMobile ? this.cardsPerView : 1;
    const trackPaddingLeft =
      parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
    const scrollLeft = this.track.scrollLeft;
    const cards = this.cards;
    let closestPage = 0;
    let minDist = Infinity;

    cards.forEach((card, i) => {
      const pageIndex = Math.floor(i / step);
      const cardOffset = card.offsetLeft - trackPaddingLeft;
      const dist = Math.abs(scrollLeft - cardOffset);
      if (dist < minDist) {
        minDist = dist;
        closestPage = pageIndex;
      }
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle("blog-carousel__dot--active", i === closestPage);
    });
  }

  updateNavState() {
    if (!this.track) return;
    const atStart = this.track.scrollLeft <= 2;
    const atEnd =
      this.track.scrollLeft + this.track.offsetWidth >=
      this.track.scrollWidth - 2;
    if (this.prevBtn) this.prevBtn.style.opacity = atStart ? "0.3" : "";
    if (this.nextBtn) this.nextBtn.style.opacity = atEnd ? "0.3" : "";
  }
}

customElements.define("blog-carousel-section", BlogCarouselSection);
